import React from 'react';
import classnames from 'classnames';
import Link from 'next/link';
import type { ConBrandInfoVo } from '@/services/swagger/data-contracts';
import LogoWithText from '@/business-components/LogoWithText';
import styles from './index.module.scss';

export type RelativeBrandCardProps = {
  className?: string;
} & ConBrandInfoVo;

const RelativeBrandCard: React.FC<RelativeBrandCardProps> = ({ conBrandId, chName, ehName, logoUrl, className }) => {
  return (
    <Link href={`/brand/${conBrandId}`}>
      <a className={classnames(styles.card, className)} target="_blank">
        <div className={styles['card-inner']}>
          <div className={styles.logo}>
            <LogoWithText
              src={logoUrl}
              width={42}
              borderRadios={6}
              chName={chName}
              ehName={ehName}
              className={styles.logoWithText}
              logoClass={styles.logoImg}
              spanClass={styles.logoSpan}
              len={4}
            />
            <span className={styles.name}>{chName || ehName}</span>
          </div>
        </div>
        <div className={styles.icon}>
          <svg className="icon" aria-hidden={true}>
            <use xlinkHref="#icon-keyboard_arrow_right" />
          </svg>
        </div>
      </a>
    </Link>
  );
};

export default RelativeBrandCard;
